import { makeStyles } from 'tss-react/mui';

/**
 * Visual parity with sampark-new's sidebar. Values mirror the design tokens in
 * libs/ui/src/globals.css and the item geometry in sampark-new's Layout.tsx:
 *
 *   --primary          3 100% 66%      active item text + tint
 *   --sidebar-foreground 240 5.3% 26.1%  item text (at 70% opacity when inactive)
 *   --sidebar-accent   240 4.8% 95.9%  hover background
 *
 * They are hardcoded rather than imported because the legacy app has no Tailwind
 * and no CSS-variable theme layer. If the new app retunes these tokens, this file
 * will drift and must be updated by hand.
 */
const PRIMARY = 'hsl(3, 100%, 66%)';
const PRIMARY_TINT = 'hsla(3, 100%, 66%, 0.1)';
const FOREGROUND = 'hsla(240, 5.3%, 26.1%, 0.7)';
const ACCENT = 'hsl(240, 4.8%, 95.9%)';

export const useSideNavStyles = makeStyles()(() => ({
  link: {
    textDecoration: 'none',
    fontSize: 16,
    fontWeight: 400,
    color: FOREGROUND,
    display: 'flex',
    alignItems: 'center',
    // gap-2 between items in the new app; horizontal inset matches its px-4 content padding
    margin: '4px 12px',
    borderRadius: 8,
    transition: 'background-color 0.15s, color 0.15s',
    '&:hover': {
      backgroundColor: ACCENT
    }
  },
  activeLink: {
    color: PRIMARY,
    background: PRIMARY_TINT,
    borderRadius: 8,
    fontWeight: 500,
    '&:hover': {
      backgroundColor: PRIMARY_TINT
    }
  },
  linkContainer: {
    // h-[44px] px-3 gap-4 in the new app
    height: 44,
    padding: '0 12px',
    display: 'flex',
    gap: 16,
    color: 'inherit',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box'
  },
  '@media (max-device-width : 736px)': {
    link: {
      paddingBottom: 0
    }
  },
  topDiv: {
    display: 'flex',
    gap: 8,
    padding: '12px 24px',
    color: '#3A4463',
    height: 68
  },
  topIconContainer: {
    height: 24,
    width: 24
  },
  icon: {
    // size-5 in the new app
    width: 20,
    height: 20,
    display: 'flex',
    color: 'inherit',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  },
  text: {
    overflow: 'hidden',
    textWrap: 'nowrap'
  },
  samparkIcon: {
    height: 24
  }
}));
